// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectList_container__orsl5"};